import React from "react";
import { Button } from "./Button";
import "../styles/HeroSection.css";
import { Container, Row, Col } from "react-bootstrap";

function HeroSection({ showGallery }) {
  return (
    <div className="hero-container home">
      <Container>
        <Row>
          <Col xsm={12} lg={6}>
            <h1 className="show-on-scroll">
              The <i>ultimate</i> solution for <br/><b>home inspections</b>
            </h1>
            <p className="show-on-scroll">
              Designed by home inspectors for home inspectors, Home Inspectors
              Toolbox helps solve your home inspection reporting needs. Simple
              and easy to use.
            </p>
            <div className="hero-btns">
              <h3>Sign up now to get your <u>30-Day FREE trial</u>!</h3>
              <Button
                className="btns"
                buttonStyle="btn--primary"
                buttonSize="btn--large"
                onClick={() => window.open('https://app.homeinspectorstoolbox.com/register', '_blank') }
              >
                Sign Up Now
              </Button>
            </div>

          </Col>
          <Col xsm={12} lg={6} style={{marginTop: 30}}>
            <div className="container text-center">
                <iframe
                    width="100%"
                    style={{ minHeight: '300px', maxHeight: '500px' }}
                    src="https://www.youtube.com/embed/5roUNDfLEJA"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                ></iframe>
            </div>
            <Row style={{ marginTop: "30px" }}>
                <Col xsm={12} lg={6} onClick={() => window.open('https://play.google.com/store/apps/details?id=com.home.inspectors.toolbox', '_blank')} style={{cursor: 'pointer'}}>
                    <img
                        src="/images/android.webp"
                        style={{ maxHeight: "50px", objectFit: "contain" }}
                        alt="home-inspectors-toolbox-preview-on-laptop-and-mobile"
                        className="img-fluid center"
                    />
                </Col>
                <Col xsm={12} lg={6} className="mt-3 mt-md-0" onClick={() => window.open('https://apps.apple.com/us/app/home-inspectors-toolbox/id6450447573', '_blank')} style={{cursor: 'pointer'}}>
                    <img
                        src="/images/ios.webp"
                        style={{ maxHeight: "50px", objectFit: "contain" }}
                        alt="home-inspectors-toolbox-preview-on-laptop-and-mobile"
                        className="img-fluid center"
                    />
                    </Col>
            </Row>
          </Col>
        </Row>

        <Row style={{marginTop: 50}}>
            <img
                src={require("../assets/images/web-banner-img.png")}
                alt="home-inspectors-toolbox-preview-on-laptop-and-mobile"
                style={{ maxHeight: "400px", objectFit: "contain" }}
                className="img-fluid"
                onClick={showGallery}
            />
        </Row>
        
      </Container>
    </div>
  );
}

export default HeroSection;
